import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { baseURL, handleAxiosError } from "./servicesUtils";
import axios from "axios";
var baseController = "".concat(baseURL, "/rest/agency");
// temporaneo, spostare su libreria o repo condivisa
function getRecaptchaToken() {
  var siteKey = "6LcvDJAqAAAAAHpOl--v_QXfELeXTHxwim1TxFIi";
  return new Promise((resolve, reject) => {
    // Controlla se lo script è già caricato
    if (!document.querySelector("script[src=\"https://www.google.com/recaptcha/api.js?render=" + siteKey + "\"]")) {
      var script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js?render=".concat(siteKey);
      script.onload = () => initRecaptcha();
      script.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
      document.body.appendChild(script);
    } else {
      initRecaptcha();
    }
    function initRecaptcha() {
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(siteKey, {
            action: "submit"
          }).then(resolve).catch(err => reject(new Error("reCAPTCHA execution failed: ".concat(err))));
        });
      } else {
        reject(new Error("reCAPTCHA is not available"));
      }
    }
  });
}
export var sendAgencyContactAsync = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    // const recaptchaToken = await getRecaptchaToken();
    // const res = await axios.post(`${baseController}/agencyContacts?captchaResponse=${recaptchaToken}`, data);
    var res = yield axios.post("".concat(baseController, "/agencyContacts"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendAgencyContactNoEmailAsync = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/agencyContactsNoEmail"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var getAgencyById = (agencyId, lang) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("/rest/agency/getAgencyByIDLang/".concat(agencyId, "/").concat(lang));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendMortgage = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("/rest/agency/sendMutuo", data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendFacileRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/sendFacileServiceRequest"), data);
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw err;
  }
});
export var getAgenciesData = function getAgenciesData(agencySearchBean) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return __awaiter(void 0, void 0, void 0, function* () {
    try {
      var res = yield axios.post("".concat(baseController, "/getListAgencyItem"), agencySearchBean, {
        params: {
          offset: offset,
          limit: limit
        }
      });
      return res.data.results;
    } catch (e) {
      handleAxiosError(e);
      throw e;
    }
  });
};
export var getMapMarkers = agencySearchBean => __awaiter(void 0, void 0, void 0, function* () {
  if (!window["_serializedAgencySearchBean"]) return;
  try {
    var res = yield axios.post("".concat(baseController, "/getAgenciesMarkers"), agencySearchBean, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw [];
  }
});